import type { ReadonlyDeep } from 'type-fest';
import type { DataItem as LegProductsCustomTableDataItem } from '@/components/customTables/LegProductsCustomTable.vue';
import type * as openapi from '@/helpers/api/types/openapiOverrides';

import { getStrCell } from '@/utils/file';

export function getTableItem(
  stopPickupProduct: ReadonlyDeep<Partial<openapi.ProductAirroadOpenapi>>,
): LegProductsCustomTableDataItem {
  return {
    id: getStrCell(stopPickupProduct._id),
    model: getStrCell(stopPickupProduct.model),
    description: getStrCell(stopPickupProduct.description),
    quantity: getStrCell(stopPickupProduct.quantity),
    weight: getStrCell(stopPickupProduct.weight),
    goodsCode: getStrCell(stopPickupProduct.weight),
  };
}

export function getTableData(
  stopPickupProducts:
    | ReadonlyDeep<Partial<openapi.ProductAirroadOpenapi>[]>
    | undefined,
): LegProductsCustomTableDataItem[] {
  const _legProductsCustomTableData: LegProductsCustomTableDataItem[] = [];
  if (!stopPickupProducts?.length) return _legProductsCustomTableData;
  stopPickupProducts.forEach(function (stopPickupProduct) {
    _legProductsCustomTableData.push(getTableItem(stopPickupProduct));
  });
  return _legProductsCustomTableData;
}
